import React from "react";
import parse from "html-react-parser";
import config from "config";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUser } from "contexts/userContext/userContext.js";

const BrandingHeaderPage = ({ pageName, pageTitle, subtitle, subtitle2 }) => {
  const { getTextByKey, getPath } = useContent();
  const { getUserData } = useUser();

  const disabledEditingByTopUser = getUserData().TopUserBrandingEnabled;

  const convertNewSubtitle = (sub) => {
    let newSub = sub;
    const supportTag = "#supportLink#";
    const demoPageTag = "#demoMailLink#";
    const demoPageUrl = "https://jumbomail.me/j/IjqbkHMdoUuulN8";
    const supportPageUrl = `${
      config.baseurl
    }${getPath()}support/subscribers/personal-branding`;
    if (pageName === "cover-logo") {
      if (sub.includes(demoPageTag)) {
        newSub = newSub.replace(demoPageTag, demoPageUrl);
      }

      if (sub.includes(supportTag)) {
        newSub = newSub.replace(supportTag, supportPageUrl);
      }
    }
    return newSub;
  };

  return (
    <div className="branding-header-page">
      <div className="branding-page-title">
        <h3>{getTextByKey(pageTitle)}</h3>
      </div>
      <div className="branding-page-subtitle">
        <div className="subtitle-text">
          {disabledEditingByTopUser
            ? getTextByKey("brandign-not-enabled")
            : parse(convertNewSubtitle(getTextByKey(subtitle)))}
        </div>
        {subtitle2 && (
          <div className="subtitle-text">
            <p>{getTextByKey(subtitle2)}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default BrandingHeaderPage;
